module.exports = __webpack_public_path__ + "static/media/more-options.02b84d2f.svg";